<template>
<div class="gp-content">
</div>
</template>

<script>
export default {
  name: 'InsightsDashboard',
  components: { },
  data() {
    return {
      filter: {
        label: '7 Days',
        since: '6 days',
        interval: 'day',
      },
    };
  },
  computed: { },
};
</script>

<style lang="scss" scoped>

</style>
